import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class FragmentCheckerService {

  constructor(private route: ActivatedRoute) {}

  public hasFragment(): boolean {
    let hasFragment = false;
    this.route.fragment.subscribe(fragment => {
      hasFragment = !!fragment;
    });
    return hasFragment;
  }
}



// WEBPACK FOOTER //
// ./src/app/helper/utils/fragment-checker.service.ts